import { render, staticRenderFns } from "./ASelector.vue?vue&type=template&id=ef0a1a48&"
import script from "./ASelector.vue?vue&type=script&lang=js&"
export * from "./ASelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports